/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Releasedate2Inputs */

const id_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Rilis`)
};

const ms_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Keluaran`)
};

const da_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivelsesdato`)
};

const de_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsdatum`)
};

const en_us2_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

const es_es2_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento`)
};

const es_mx2_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento`)
};

const fil_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Release`)
};

const fr_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de sortie`)
};

const it_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di uscita`)
};

const hu_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelenés dátuma`)
};

const nl_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasedatum`)
};

const no_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivelsesdato`)
};

const pl_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data wydania`)
};

const pt_br2_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento`)
};

const pt_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento`)
};

const ro_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data lansării`)
};

const fi_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisupäivä`)
};

const sv_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasedatum`)
};

const vi_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phát hành`)
};

const tr_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış Tarihi`)
};

const cs_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vydání`)
};

const bg_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на издаване`)
};

const ru_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата выхода`)
};

const uk_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата виходу`)
};

const ar_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإصدار`)
};

const hi_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ तारीख़`)
};

const th_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่วางจำหน่าย`)
};

const ja_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース日`)
};

const zh_cn2_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布日期`)
};

const zh_hant1_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發布日期`)
};

const ko_offerdetail_table_releasedate2 = /** @type {(inputs: Offerdetail_Table_Releasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시일`)
};

/**
* | output |
* | --- |
* | "Release Date" |
*
* @param {Offerdetail_Table_Releasedate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_releasedate2 = /** @type {((inputs?: Offerdetail_Table_Releasedate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Releasedate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_releasedate2(inputs)
	if (locale === "ms") return ms_offerdetail_table_releasedate2(inputs)
	if (locale === "da") return da_offerdetail_table_releasedate2(inputs)
	if (locale === "de") return de_offerdetail_table_releasedate2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_releasedate2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_releasedate2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_releasedate2(inputs)
	if (locale === "fil") return fil_offerdetail_table_releasedate2(inputs)
	if (locale === "fr") return fr_offerdetail_table_releasedate2(inputs)
	if (locale === "it") return it_offerdetail_table_releasedate2(inputs)
	if (locale === "hu") return hu_offerdetail_table_releasedate2(inputs)
	if (locale === "nl") return nl_offerdetail_table_releasedate2(inputs)
	if (locale === "no") return no_offerdetail_table_releasedate2(inputs)
	if (locale === "pl") return pl_offerdetail_table_releasedate2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_releasedate2(inputs)
	if (locale === "pt") return pt_offerdetail_table_releasedate2(inputs)
	if (locale === "ro") return ro_offerdetail_table_releasedate2(inputs)
	if (locale === "fi") return fi_offerdetail_table_releasedate2(inputs)
	if (locale === "sv") return sv_offerdetail_table_releasedate2(inputs)
	if (locale === "vi") return vi_offerdetail_table_releasedate2(inputs)
	if (locale === "tr") return tr_offerdetail_table_releasedate2(inputs)
	if (locale === "cs") return cs_offerdetail_table_releasedate2(inputs)
	if (locale === "bg") return bg_offerdetail_table_releasedate2(inputs)
	if (locale === "ru") return ru_offerdetail_table_releasedate2(inputs)
	if (locale === "uk") return uk_offerdetail_table_releasedate2(inputs)
	if (locale === "ar") return ar_offerdetail_table_releasedate2(inputs)
	if (locale === "hi") return hi_offerdetail_table_releasedate2(inputs)
	if (locale === "th") return th_offerdetail_table_releasedate2(inputs)
	if (locale === "ja") return ja_offerdetail_table_releasedate2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_releasedate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_releasedate2(inputs)
	return ko_offerdetail_table_releasedate2(inputs)
});
export { offerdetail_table_releasedate2 as "offerDetail.table.releaseDate" }